import React, { FC } from 'react';
import DealerLogin from '../dealerLogin';
import MarketSelector from '../marketSelector';
import LanguageSelector from '../languageSelector';
import { ActionSectionModel } from './models/actionSection.model';
import { ActionSectionProps } from './types/actionSection.types';

const ActionSection: FC<ActionSectionProps> = (props) => {
  const model = new ActionSectionModel(props);

  return (
    <div className="footer-action-section">
      <MarketSelector fields={model.marketSelector} />
      {model?.languageSelector?.list && model?.languageSelector?.list?.length > 1 && <LanguageSelector fields={model.languageSelector} />}
      <DealerLogin fields={model.dealerLink} />
    </div>
  );
};

export default ActionSection;
